import { Component } from "react"
import PropTypes from "prop-types"
import { AGGREGATION } from "../../shapes"
import "./style.scss"
import { ArrowDropDown, ArrowRight } from "@mui/icons-material"

class Aggregation extends Component {
  onClick = () => {
    const { toggleAggregation, row: { aggregationType } } = this.props
    toggleAggregation(aggregationType)
  }

  render() {
    const { row: { aggregationType, open }, children } = this.props

    let onClick
    if (open !== undefined) {
      onClick = this.onClick
    }

    return <tr className="row aggregation">
      <th onClick={onClick}>
        {open === false && <ArrowRight />}
        {open === true && <ArrowDropDown />}
        {open === undefined && <span className="spacer" />}
        {aggregationType}
      </th>
      {children}
    </tr>
  }
}

Aggregation.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  row: AGGREGATION.isRequired,
  toggleAggregation: PropTypes.func.isRequired,
}

export default Aggregation
